import { Component, Input } from '@angular/core';
import { Theme } from '../theme';

@Component({
    selector: 'app-themed-background',
    templateUrl: './themed-background.component.html',
    styleUrls: ['./themed-background.component.scss'],
    standalone: false
})
export class ThemedBackgroundComponent {
  @Input()
  theme: Theme;

  get backgroundStyle() {
    return {
      'background-color': this.theme.backgroundColor
    };
  }
}
